function PrivacyPolicyPage(){
    return(
        <iframe src="https://remai.jdfasia.com/downloads/privacy-policy.pdf" width="100%" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreenameborder="0" title="Membership Rules" style={{height:"100vh"}}></iframe>      
    );
}

export default PrivacyPolicyPage;